import React from 'react';
import { ROLES, ROLE_MENU_NAMES } from 'constants/roles';

class MainNavigationComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  componentDidMount() {
    const { user, changeMenu } = this.props;

    changeMenu(user.getActiveRole());
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.closeMenu);
  }

  handleResetManufacturer = () => {
    const { user } = this.props;

    user.goToDashboard();
  };

  getBackToDashboardButton = () => {
    const { user } = this.props;
    const manufacturerNameToDisplay = `${user.getManufacturerName()} (${user.getManufacturerCode()})`;
    const inspectorNameToDisplay = `${user.getInspectorName()} (${user.getInspectorCode()})`;



    if (!user.isInternal() && !user.isInspector())
      return (
        <div className='to-dashboard-button'>
          <div className='dash' />
          {manufacturerNameToDisplay}
        </div>
      );

    if (user.selectedManufacturer) {
      return (
        <div className='to-dashboard-button' onClick={this.handleResetManufacturer}>
          <div className='dash' />
          <div className='icon' />
          {manufacturerNameToDisplay}
        </div>
      );
    }

    if (user.selectedInspector)
      return (
        <div className='to-dashboard-button' onClick={user.selectInspector(null)}>
          <div className='dash' />
          <div className='icon' />
          {inspectorNameToDisplay}
        </div>
      );

    return (
      <div className='to-dashboard-button'>
        <div className='dash' />
      </div>
    );
  };

  getActiveMenu = () => {
    const { user } = this.props;
    let classes = user.isMultipleRoles() ? 'active-menu-item multiple-menu-item' : 'active-menu-item';

    return (
      <div className={classes} onClick={this.handleActiveMenuClick}>
        {ROLE_MENU_NAMES[user.getActiveRole()]}
        {this.getMenuList()}
      </div>
    );
  };

  getMenuList = () => {
    const { isOpen } = this.state;
    const { user } = this.props;

    let menuList = [];

    const getMenuElement = role => {
      if (!ROLE_MENU_NAMES[role]) return null;

      return (
        <div className='menu-list-item' key={role} onClick={this.handleMenuClick(role)}>
          {ROLE_MENU_NAMES[role]}
        </div>
      );
    };

    const deleteRolesWithSameMenuListLink = rolesList => {
      let unDuplicatedList = rolesList.filter((roleToCheckForDuplicates, roleToCheckIndex) => {
        let roleToCheckMenuEntryName = ROLE_MENU_NAMES[roleToCheckForDuplicates];
        let followingDuplicatesList = rolesList.filter((possibleDuplicateRole, possibleDuplicateIndex) => {
          return (
            roleToCheckMenuEntryName === ROLE_MENU_NAMES[possibleDuplicateRole] &&
            roleToCheckIndex < possibleDuplicateIndex
          );
        });

        return followingDuplicatesList.length === 0;
      });
      return unDuplicatedList;
    };

    if (user.isInternal()) {
      let allRolesServerNamesList = Object.keys(ROLES).map(roleKey => ROLES[roleKey].serverName);
      menuList = deleteRolesWithSameMenuListLink(allRolesServerNamesList)
        .filter(role => role !== user.getActiveRole())
        .map(role => getMenuElement(role))
        .filter(element => element);
    } else if (user.isInspector()) {
      let allRolesServerNamesList = Object.keys(ROLES).map(roleKey => ROLES[roleKey].serverName);
      menuList = allRolesServerNamesList
        .filter(role => {
          return (
            (role === ROLES.BOAT_MANUFACTURER.serverName || role === ROLES.TRAILER_MANUFACTURER.serverName) &&
            role !== user.getActiveRole()
          );
        })
        .map(role => getMenuElement(role))
        .filter(element => element);
    } else {
      menuList = deleteRolesWithSameMenuListLink(user.roles)
        .filter(role => role !== user.getActiveRole())
        .map(role => getMenuElement(role))
        .filter(element => element);
    }

    const classes = `menu-list ${isOpen ? ' open' : ''}`;

    const resultList = [];
    for (let i = 0; i < menuList.length - 1; i++) {
      resultList.push(menuList[i]);
      resultList.push(<hr key={`hr_${i}`} />);
    }
    resultList.push(menuList[menuList.length - 1]);

    return <div className={classes}>{resultList}</div>;
  };

  handleActiveMenuClick = () => {
    const { isOpen } = this.state;

    if (isOpen) {
      this.closeMenu();
    } else {
      this.setState({ isOpen: true });
      document.addEventListener('click', this.closeMenu);
    }
  };

  closeMenu = () => {
    this.setState({ isOpen: false });
    document.removeEventListener('click', this.closeMenu);
  };

  handleMenuClick = role => () => {
    const { user } = this.props;
    let roleNameForURL = '';
    Object.keys(ROLES).forEach(roleKey => {
      if (ROLES[roleKey].serverName === role) roleNameForURL = ROLES[roleKey].nameForUrl;
    });
    if (user.isInspector() || user.isInternal()) {
      user.goToDashboard(roleNameForURL);
    } else {
      user.goToSummary(user.getManufacturerCode(), roleNameForURL);
    }
  };

  render() {
    const { user } = this.props;
    if (!user.roles || !user.roles.length) return null;

    return (
      <nav className='main-navigation _z_index_max'>
        {this.getBackToDashboardButton()}
        {this.getActiveMenu()}
      </nav>
    );
  }
}

export default MainNavigationComponent;



// WEBPACK FOOTER //
// ./src/app/Routing/Header/MainNavigation.jsx